<template>
	<svg
		width="22px"
		height="17px"
		viewBox="0 0 22 17"
		version="1.1"
		xmlns="http://www.w3.org/2000/svg"
		xmlns:xlink="http://www.w3.org/1999/xlink"
		alt="active speaker icon"
	>
		<title>Switch to Active Speaker</title>
		<g
			id="ActiveSpeaker"
			stroke="none"
			stroke-width="1"
			fill="none"
			fill-rule="evenodd"
		>
			<g
				id="ActiveSpeakerEdit"
				transform="translate(-1036.000000, -22.000000)"
				:fill="fill"
			>
				<path
					d="M1041.3376,32.1313127 C1041.70343,32.1313127 1042,32.4278793 1042,32.7937127 L1042,38.3376 C1042,38.7034334 1041.70343,39 1041.3376,39 L1036.6624,39 C1036.29657,39 1036,38.7034334 1036,38.3376 L1036,32.7937127 C1036,32.4278793 1036.29657,32.1313127 1036.6624,32.1313127 L1041.3376,32.1313127 Z M1049.3376,32.1313127 C1049.70343,32.1313127 1050,32.4278793 1050,32.7937127 L1050,38.3376 C1050,38.7034334 1049.70343,39 1049.3376,39 L1044.6624,39 C1044.29657,39 1044,38.7034334 1044,38.3376 L1044,32.7937127 C1044,32.4278793 1044.29657,32.1313127 1044.6624,32.1313127 L1049.3376,32.1313127 Z M1057.3376,32.1313127 C1057.70343,32.1313127 1058,32.4278793 1058,32.7937127 L1058,38.3376 C1058,38.7034334 1057.70343,39 1057.3376,39 L1052.6624,39 C1052.29657,39 1052,38.7034334 1052,38.3376 L1052,32.7937127 C1052,32.4278793 1052.29657,32.1313127 1052.6624,32.1313127 L1057.3376,32.1313127 Z M1057.3376,22 C1057.70343,22 1058,22.2965666 1058,22.6624 L1058,29.0648733 C1058,29.4307066 1057.70343,29.7272732 1057.3376,29.7272732 L1036.6624,29.7272732 C1036.29657,29.7272732 1036,29.4307066 1036,29.0648733 L1036,22.6624 C1036,22.2965666 1036.29657,22 1036.6624,22 L1057.3376,22 Z"
					id="Combined-Shape"
				></path>
			</g>
		</g>
	</svg>
</template>

<script>
export default {
	Name: 'ActiveSpeaker',
	props: ['active'],

	computed: {
		fill() {
			return this.active ? '#ffffff' : '#484848'
		},
	},
}
</script>
